"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAuthWindow = void 0;
var EventTypes_1 = require("../enum/EventTypes");
var events_1 = require("../utils/events");
function openAuthWindow() {
    events_1.sendEvent(EventTypes_1.EventTypes.OpenAuthWindow);
}
exports.openAuthWindow = openAuthWindow;
//# sourceMappingURL=actions.js.map